import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import BenefitsSection from "./components/BenefitsSection";
import ComparisonSection from "./components/ComparisonSection";
import ContentSection from "./components/ContentSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BenefitsSection />
        <ComparisonSection />
        <ContentSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}